export default __webpack_public_path__ + "media/svgs/trash-588eeb34.svg";